/**
 * Convert pixels to percentages using wrapping container
 * @param size
 * @param container
 * @returns {string}
 */
const convertPxToPercentages = (size, container) => `${(size / container) * 100}%`

export default convertPxToPercentages
